<style lang="scss" scoped>

    .myAmpleon .main .container {
        width: auto;
    }

    .button-results {
        margin-top: 30px;
        margin-bottom: 30px;
        margin-left: 30px;
        float: left;

        .btn-default {
            background-color: #00a8e1;
            color: #ffffff;
        }
    }

    .notification-wrapper-row {
        width: auto;
        text-align: center;
        margin-top: 60px;
    }

    .categories-container {
        background-color: #ffffff;
        margin-top: 29px;
        margin-bottom: 21px;
    }

    .category-item-details a {
        color: #00a8e1;

    }

    .products-button {
        margin-right: 5px;
    }


    @media (max-width: 768px) {
        .button-results {
            margin-left: 0;
        }

        .category-items {
            padding-left: 13px !important;
        }
    }

    .category-sidebar li {
        line-height: 29px;
    }

    .categories-container .categories-content-wrapper .category-items .category-item:last-child {
        border-bottom: 1px solid #f1f1f2;
    }

    .categories-container .categories-content-wrapper .category-sidebar ul li.nav-item {
        @media (max-width: 768px) {
            font-size: 20px;
        }

        a.nav-link {
            text-transform: none;
        }
    }

    .categories-container .categories-content-wrapper .category-sidebar {
        margin-top: 13px;
    }

    // Utility classes

    .h-font-14 {
        font-size: 14px !important;
    }

    .h-color-darkblue {
        color: #337AB7 !important;
    }

    .h-padding-0 {
        padding: 0 !important;
    }

    .h-padding-top-0 {
        padding-top: 0 !important;
    }

    .h-color-darkgray {
        color: #B6B6B6 !important;
    }

    .alert-notification {
        margin-left: 30px;
        font-size: 1.25rem;
        margin-top: 20px;
    }

    //iPhone 8 fix position of dropdown button
    @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
        .category-sidebar ul i {
            right: 50px !important;
        }
    }
</style>

<template>
    <div class="categories-container">
        <div class="categories-content-wrapper">

            <!-- Side bar Menu Items -->
            <div class="col-md-3 category-sidebar" :class="expanded === true ? 'expanded-section-nav' : ''">
                <ul class="nav md-pills pills-primary flex-column" role="tablist">

                    <i class="fa fa-chevron-circle-down" :class="expanded === true ? 'expanded-section-icon' : ''"
                       @click="arrowButton()"></i>

                    <li v-if="this.isAdmin" id="nav-item-alerts" class="nav-item visible-nav-items"
                        v-bind:class="[activetab === 'myAlerts' ? 'active' : '']">
                        <a class="nav-link active" data-toggle="tab" data-category="alerts" role="tab"
                           v-on:click="setActiveTab('myAlerts')">
                            myAlerts
                        </a>
                    </li>

                    <li id="nav-item-products" class="nav-item visible-nav-items"
                        v-bind:class="[activetab === 'latestProducts' ? 'active' : '']">
                        <a class="nav-link" data-toggle="tab" data-category="Latest-Products" role="tab"
                           v-on:click="setActiveTab('latestProducts')">
                            Latest products
                        </a>
                    </li>

                    <li id="nav-item-documents" class="nav-item visible-nav-items"
                        v-bind:class="[activetab === 'latestDocuments' ? 'active' : '']">
                        <a class="nav-link" data-toggle="tab" data-category="Latest-Documents" role="tab"
                           v-on:click="setActiveTab('latestDocuments')">
                            Latest documents
                        </a>
                    </li>
                </ul>
            </div>

            <div class="col-md-9 category-items">
                <div class="tab-content vertical">

                    <!--Items for myAlert-->
                    <div class="tab-pane fade in active" id="alerts" role="tabpanel" v-if="activetab === 'myAlerts'"
                         v-bind:class="[activetab === 'myAlerts' ? 'active' : '']">
                        <div v-for="task in tasks" class="category-item col-md-12">
                            <div class="category-item-info col-md-8">
                                <router-link :to="{path: '/my-admin'}">
                                    <span class="category-item-title h-padding-0">
                                        <a class="category-item-title-anchor h-font-14 h-color-darkblue">New {{task.type}}</a>
                                    </span>
                                </router-link>
                                <span class="category-item-intro h-padding-0">
                                    <p>{{getTaskContent(task)}}</p>
                                </span>
                                <span class="category-item-date h-color-darkgray h-padding-top-0">{{task.date.toLocaleString()}}</span>
                                <span class="category-item-details">
                                     <router-link :to="{path: '/my-admin'}">
                                         <a class="h-font-14 h-color-darkblue" href="">Review</a>
                                     </router-link>
                                </span>
                            </div>
                        </div>

                        <p class="alert-notification" v-if="tasks && !tasks.length">
                            No new alerts available!
                        </p>
                    </div>

                    <!--Items for Latest Products-->
                    <div class="tab-pane fade in" id="Latest-Products" role="tabpanel"
                         v-if="activetab === 'latestProducts'"
                         v-bind:class="[activetab === 'latestProducts' ? 'active' : '']">
                        <div v-for="item in latestProductsItems" class="category-item col-md-12">
                            <div class="category-item-info col-md-8">
                                <span class="category-item-title h-padding-0">
                                    <a class="category-item-title-anchor h-font-14 h-color-darkblue"
                                       :href="item.productLink">{{item.productCode}}</a>
                                </span>
                                <span class="category-item-intro h-padding-0">
                                    <p>{{item.description}}</p>
                                </span>
                                <span class="category-item-date h-color-darkgray h-padding-top-0">
                                    {{item.date.toLocaleDateString()}}
                                </span>
                                <span class="category-item-details">
                                    <a class="h-font-14 h-color-darkblue"
                                       :href="getProductLink(item.productLink)">Product Details</a>
                                    <a v-if="item.dataSheetLink !== null" class="h-font-14 h-color-darkblue"
                                       :href="item.dataSheetLink"> | Datasheet</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!--Items for Latest Documents-->
                    <div class="tab-pane fade in" id="Latest-Documents" role="tabpanel"
                         v-if="activetab === 'latestDocuments'"
                         v-bind:class="[activetab === 'latestDocuments' ? 'active' : '']">
                        <div v-for="document in documents" class="category-item col-md-12">
                            <div class="category-item-info col-md-8">
                                <span class="category-item-title h-padding-0">
                                    <a class="category-item-title-anchor h-font-14 h-color-darkblue"
                                       :href=document.link>{{document.name}}</a>
                                </span>
                                <span class="category-item-intro h-padding-0">
                                    <p>{{document.title}}</p>
                                </span>
                                <span class="category-item-date h-color-darkgray h-padding-top-0">{{document.date.toLocaleDateString()}}</span>
                                <span class="category-item-details">
                                    <a class="h-font-14 h-color-darkblue" :href=document.link>Download</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="button-results">
                        <router-link :to="{path: getTabPath()}">
                            <button type="submit" class="btn btn-primary register-button products-button">
                                {{getButtonText()}}
                            </button>
                        </router-link>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {FETCH_TASKS, FETCH_DOCUMENTS} from "../store/actions.type";
    import {QUERY_CHANGED} from "../store/mutations.type";
    import {ProductsService} from "../common/api.service";

    export default {
        name: "Notifications",
        data() {
            return {
                activetab: 'myAlerts',
                expanded: false,
                latestProductsItems: []
            }
        },
        computed: {
            ...mapGetters("myAdmin", ["tasks"]),
            ...mapGetters(["isAdmin"]),
            ...mapGetters("myDocuments", ["documents"]),
        },

        mounted() {
            if (!this.isAdmin) {
                this.activetab = "latestProducts";
                ProductsService.getLatestProducts({maxResults: 5}).then(({data}) => {
                    data.items.forEach(item => item.date = new Date(item.date));
                    this.latestProductsItems = data.items;
                });
            } else {
                this.$store.commit('myAdmin/' + QUERY_CHANGED, {
                    q: "",
                    sort: "",
                    order: "",
                    page: 0,
                    pageSize: 5,
                    status: 'Created'
                });
                this.$store.dispatch('myAdmin/' + FETCH_TASKS);
            }
        },
        methods: {
            setActiveTab(tab) {
                switch (tab) {
                    case 'myAlerts':
                        this.activetab = 'myAlerts';
                        this.$store.commit('myAdmin/' + QUERY_CHANGED, {
                            q: "",
                            sort: "",
                            order: "",
                            page: 0,
                            pageSize: 5,
                            status: 'Created'
                        });
                        this.$store.dispatch('myAdmin/' + FETCH_TASKS);
                        break;
                    case 'latestDocuments':
                        this.activetab = 'latestDocuments';
                        this.$store.commit('myDocuments/' + QUERY_CHANGED, {
                            category: "All",
                            sort: "releaseDate",
                            order: "desc",
                            page: 0,
                            pageSize: 5
                        });
                        this.$store.dispatch('myDocuments/' + FETCH_DOCUMENTS);
                        break;
                    case  'latestProducts':
                        this.activetab = 'latestProducts';
                        ProductsService.getLatestProducts({maxResults: 5}).then(({data}) => {
                            data.items.forEach(item => item.date = new Date(item.date));
                            this.latestProductsItems = data.items;
                        });
                        break;
                }
            },
            getTabPath() {
                switch (this.activetab) {
                    case 'myAlerts':
                        return '/my-admin';
                    case 'latestProducts':
                        return '/my-parametric-search';
                    case 'latestDocuments':
                        return '/my-documents';
                }
            },
            getButtonText() {
                switch (this.activetab) {
                    case 'myAlerts':
                        return 'View All Tasks';
                    case 'latestProducts':
                        return 'Parametric Search';
                    case 'latestDocuments':
                        return 'Document Library';
                }
            },
            getTaskContent(item) {
                if (item.type === "Document approval") {
                    return item.document.documentName
                } else if (item.type === "User Registration") {
                    return item.requestor
                }
            },
            getProductLink(link) {
                return window.location.pathname.split('/my-ampleon')[0] + link;
            },
            arrowButton() {
                this.expanded === true ? this.expanded = false : this.expanded = true;
            }
        }
    };
</script>

